// Table
import Page from './ChartTemplate.vue';
export default Page;